<template>
    <main class="content">
        <div class="row">
            <h1>
                Add new partner
            </h1>
        </div>
        <form novalidate v-on:submit.prevent="addPartner" class="form">
            <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

            <fieldset class="form--item">
                <label class="label" for="">
                    Partner name:
                </label>
                <div class="input_text" id="name">
                    <input name="" required v-model="partner.name" placeholder="Write a name" type="text" value=""/>
                </div>
            </fieldset>
            <fieldset class="form--item">
                <label class="label" for="">
                    Percentage of revenue shared:
                </label>
                <div class="input_text" id="revenueShare">
                    <input name="" placeholder="Define a percentage of revenue for each video of this partner" required v-model="partner.revenueShare" type="text" value=""/>
                </div>
            </fieldset>
            <div class="row">
                <button class="btn btn_blue" type="submit">
                    Add Partner
                </button>
            </div>
        </form>
        <loading :visible.sync="loadingVisible"></loading>
    </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

export default {
  name: 'AddPartner',
  components: {Message, Loading},
  mixins:[ValidateForm, CreateResource],
  data () {
    return {
      partner: {},
      resource: 'partners',
      parentResource: 'Partners',
      required_fields: [
        {'attribute': 'partner.name', 'message': 'Name is missing', 'id': 'name'},
        {'attribute': 'partner.revenueShare', 'message': 'Revenue share is missing', 'id': 'revenueShare'},
      ]
    }
  },
  methods: {
    addPartner(){
      this.createResource(this.partner);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AddPartners.vue?ed586c88